import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { SignFormProps } from './SignForm';
import type { SignFormContainerRefreshWrapperContainer } from './SignFormContainerRefreshWrapper';

async function loadSignForm(): Promise<typeof SignFormContainerRefreshWrapperContainer> {
	return (await import(/* webpackChunkName: "pages/petition_details_sign_form" */ './SignFormContainerRefreshWrapper'))
		.SignFormContainerRefreshWrapperContainer;
}

export const SignFormLoader: React.FC<SignFormProps> = (props) => {
	return <LazyComponent loadComponent={loadSignForm} fallback={<Loader size="s" mt={64} mx="auto" />} {...props} />;
};

export const preloadSignForm = loadSignForm;
